/**
 * The required preset WDX Date format
 * - Absolute dates are used where a full timestamp is appropriate.
 * - Relative dates are used in where the users focus will be on the date relative to the current time.
 * - TimeAgo dates display time-based relative strings (e.g., "11 hours ago", "2 days ago").
 */
export enum WdxDateFormat {
    AbsoluteDate,
    AbsoluteDateTime,
    RelativeDate,
    RelativeDateTime,
    TimeAgoDate,
    TimeAgoDateTime,
    TimeOnly,
}

/**
 * This is the WdxDateOptions options interface
 *
 * @prop locale - This needs to be the isoCode e.g 'en-US', 'en-UK'
 * @prop format - WdxDateFormat
 */
export interface WdxDateOptions {
    locale?: string | null;
    format?: WdxDateFormat;
}
